import { Box, Button, Container, FormControl, Grid, InputLabel, MenuItem, NativeSelect, Select, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Label } from 'semantic-ui-react';
import axios from "axios";
import { useCheckChain } from '../../../Hooks/useCheckChain';
import { ABI, ABINotarize, API_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid ,Notarizematicaddress } from '../../../Config';
import { useWeb3React } from '@web3-react/core';
import swal from "sweetalert";
import Loading from "../../../Components/loader/loader";
import Swal from 'sweetalert2';
// require('dotenv').config();
import { useHistory } from "react-router-dom";
import Nftstats from './Nftstats';
import Nftproperties from './Nftproperty';
import NFTLevels from './Nftlevel';

const Notarize = () => {
    const { account, library, chainId } = useWeb3React();
    // const [hashipfs, sethash] = useState();
    const [category, setcategorydata] = useState([]);
    const [Categoryvalue, setcategory] = useState("");
    const [collection, setcollection] = useState([]);
    const [collectionvalue, setcollectionvalue] = useState("");
    const [isloading, setisloading] = useState(false);
    const [state, setState] = useState([])
    const [property ,setProperty]= useState([])
    const [level ,setlevel]= useState([]);
    const redirect = useHistory();
    const [nfttype,Settypenft] =useState(1);
    const [disable,setdisable] =useState(false);
    const [royalty,setroyalty]=useState('');
    const [getimage,setimage]=useState('');

    // const JWT =process.env.PINATAJWT;
    const JWT = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJlNzVhZjZiZS0yM2RjLTRiNjQtODZhMy01ZTNkOTA4NjY4NTIiLCJlbWFpbCI6InBla29yZXkzNTlAdm9vdGluLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiRlJBMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfSx7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiI2MGRhNWRmYThmMzJjZGY2ZTNjMSIsInNjb3BlZEtleVNlY3JldCI6IjBmMzUyMjgxODk4Nzc0Y2RlN2E4NmY5OTBjMTZjMjE2MDAwOGIwOWZhYzE4ZDhmMzY4YzRkMTNjOGIyYTljZjkiLCJpYXQiOjE2Nzc2NzU2NTl9.ZC5X4sR2FXaxCPPtEG4ZcRHGkMaEeb7n8JXTJz5_wo8'
    const { switchChain } = useCheckChain();

    function changecurrency(e) {
        let currency = e.target.value;
        if (currency == "BNB") {
            switchChain(Bsc_Chainid);
        } else if (currency == "MATIC") {
            switchChain(Matic_Chainid);
        } else if (currency == "ETH") {
            switchChain(ETH_Chainid);
        }
    }

    const categorydata = async () => {
        await axios
            .post(`${API_URL}/indexData.php?type=category`, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(async (req) => {
                if (req.data) {
                    setcategorydata(req.data);
                }
            })
            .catch((res) => {});
    };

    const collectiondata = async () => {
        var data = new FormData();
        data.append("address", account)
        data.append("action", "fetchcollection");

        await axios
            .post(`${API_URL}/createCollection.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(async (req) => {
                if (req.data) {
                    setcollection(req.data);
                }
            })
    };

    useEffect(() => {
        if (collection.length == 0) {
            collectiondata();
        }

    }, [collection, account]);

    const handlesubmit = async (e) => {
        
        e.preventDefault();
        const image = e.target.image.files[0];
        const Name = e.target.title.value;
        const description = e.target.description.value;
        const royalty = e.target.royalty.value;
        const price = e.target.price.value;
        const currency = e.target.currency.value;
        const category = e.target.category.value;
        const tokenId = Math.floor(Math.random() * 1000000);

        if (library) {
            let selectedchainid;
            if (currency == "BNB") {
                selectedchainid = Bsc_Chainid;
            } else if (currency == "MATIC") {
                selectedchainid = Matic_Chainid;
            } else if (currency == "ETH") {
                selectedchainid = ETH_Chainid;
            }

            if (chainId === selectedchainid) {
                let contract_address;
                if (chainId === Bsc_Chainid) {
                    contract_address = bsccontractaddress
                } else if (chainId === Matic_Chainid) {
                    contract_address = Notarizematicaddress
                } else if (chainId === ETH_Chainid) {
                    contract_address = ethcontractaddress
                }

               
            
                if (Name !== "" && description !== "" && price > 0 && nfttype!=="" && image !== "" && royalty !== "" && category !== "" && collectionvalue!=="") {
                    if (royalty <= 50) {
                        setisloading(true);
                        let response = await updatedata(Name, description, price, royalty, image, tokenId, currency, category, collectionvalue,state, property, level, contract_address,nfttype)
                        let res = await getMetadata(image, tokenId, Name, description ,state, property, level);
                        let notrevealeduri = await getNotRevealeddata(tokenId);
                       
                        if (response.data.code == 200) {
                            let url = "ipfs://" + res.data.IpfsHash;
                            let revealurl ="ipfs://" + notrevealeduri.data.IpfsHash;
                            let isrevealed;
                            let IpfsHash='';
                            if(nfttype==1){
                                //private 
                                isrevealed=false;
                                IpfsHash=notrevealeduri.data.IpfsHash;
                            }else if(nfttype==0){
                                //public
                                isrevealed=true;
                                IpfsHash=res.data.IpfsHash;
                            }
                            
                            const Web3 = require('web3');
                            const web3 = new Web3(library.provider);
                            const contract = await new web3.eth.Contract(ABINotarize, contract_address);
                            let value = web3.utils.toWei(price.toString(), "ether");
                            let creationfee = await contract.methods.creationFees().call();

                            let fees = "0";
                            let feevalue = 0;
                            if (creationfee > 0) {
                                fees = '0';
                                feevalue = price * creationfee / 100;
                                feevalue = web3.utils.toWei(feevalue.toString(), "ether");
                            }

                            await contract.methods.mintNFT(url,revealurl,isrevealed,fees, tokenId.toString(), false, value, contract_address, royalty.toString()).estimateGas({
                                from: account.toString(),
                                value: feevalue
                            })

                            await contract.methods.mintNFT(url,revealurl,isrevealed,fees, tokenId.toString(), false, value, contract_address, royalty.toString()).send({
                                from: account.toString(),
                                value: feevalue
                            }).then(() => {
                               
                                    Swal.fire({
                                        title: "Congratulations! You successfully minted NFT ",
                                        html: `<a href="https://gateway.pinata.cloud/ipfs/${IpfsHash && IpfsHash}" target="blank">IPFS HASH</a>`,
                                        icon: "success",
                                        allowOutsideClick: false,
                                        confirmButtonText: 'ok',
                                        confirmButtonColor: '#2dbe60',
                                    }).then(() => {
                                            redirect.push('./Myitem');
                                        });
                              
                                setisloading(false)
                            }).catch(() => {
                                deletenft(tokenId);
                                setisloading(false);
                            })
                        } else {
                            setisloading(false);
                              deletenft(tokenId);
                            swal({
                                title: "Warning",
                                text: "Data is  not uploaded ",
                                icon: "error",
                                allowOutsideClick: false,
                                confirmButtonText: 'ok',
                                confirmButtonColor: '#2dbe60',
                            })
                        }

                    } else {
                        setisloading(false);
                        swal({
                            title: "error",
                            text: "Please enter the royalty less than 50!",
                            icon: "error",
                            allowOutsideClick: false,
                            confirmButtonText: 'ok',
                            confirmButtonColor: '#2dbe60',
                        }).then(() => {
                            });
                    }

                } else {
                    setisloading(false);
                    swal({
                        icon: "error",
                        text: 'Please fill all the required details',
                        title: "error",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    })
                }

            } else {
                switchChain(selectedchainid);
            }

        } else {
            swal({
                icon: "error",
                text: 'Please connect your wallet First',
                title: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }

    }

    const deletenft=async(NFTid)=>{
        var data =new FormData();
        data.append("NFT_id",NFTid);
      
        return await axios.post(`${API_URL}/DeleteNft.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

    const PinFiletoIPFS = async (image) => {
        const formData = new FormData();
        formData.append('file', image);
        try {
            return await axios.post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
                maxBodyLength: "Infinity",
                headers: {
                    'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
                    Authorization: JWT
                }

            });
        } catch (error) {
            console.log(error);
        }
    }

    const getMetadata = async(image,NFTid,NFTname,Description,state, property, level)=>{
        const attribute =[];
        if(state!=""){
          for(let i=0;i<state.length;i++){
            let stateattribute={
                    "trait_type": state[i].name,
                    "value" :state[i].value
                  }
                attribute.push(stateattribute);
          }
        }
       
        if(level!=""){
          for(let i=0;i<level.length;i++){
            let levelattribute={
                    "trait_type": level[i].name,
                    "value" :level[i].value
                  }
                attribute.push(levelattribute);
          }
        }
      
      if(property!=""){
        for(let i=0;i<property.length;i++){
          let propertyattribute={
                  "trait_type": property[i].name,
                  "value" :property[i].value
                }
              attribute.push(propertyattribute);
        }
      }
      
        const imageurl = await PinFiletoIPFS(image);
        const body =JSON.stringify({
            NFT_id:NFTid,
            name: NFTname,
            description: Description,
            image:"ipfs://"+imageurl.data.IpfsHash,
            attributes:attribute
        })
        return await PinJsontoIPFS(body);
  
    }

    const getNotRevealeddata= async(NFTid)=>{
        const body =JSON.stringify({
            NFT_id:NFTid,
            name: "SECRET NFT",
            description: "Exclusive collection of ENEFTI. Each NFT will be valuable . Every trait has a specific ability in our Metaverse. Special Giveaways and airdrops for holders!",
            image:"ipfs://QmQL1hrgis5GtZuZFgngYpvyHcb1PZ5JChtY27bMxi23Ue"
        })
        return await PinJsontoIPFS(body);

    }
    const PinJsontoIPFS = async (data) => {
        try {
            return await axios.post("https://api.pinata.cloud/pinning/pinJSONToIPFS", data, {
                maxBodyLength: "Infinity",
                headers: {
                    'Content-Type': `application/json`,
                    Authorization: JWT
                },

            });

        } catch (error) {
            console.log(error);
        }
    }

    const updatedata = async (NFTname, description, price, royalty, fileImg, tokenId, currency, category, collection, state, property, level,contract_address,Private) => {
        let statename;
        let statevalue;
        let propertyname;
        let propertyvalue;
        let levelname;
        let levelvalue;

        if (state != "" || property != "" || level != "") {
          //  state values
          statename = state.map(e => e.name).join(",");
          statevalue = state.map(e => e.value).join(",");
          // property values
          propertyname = property.map(e => e.type).join(",");
          propertyvalue = property.map(e => e.propname).join(",");
          // level values
          levelname = level.map(e => e.name).join(",");
          levelvalue = level.map(e => e.value).join(",");
        }
        
        var data = new FormData();
        data.append("NFT_name", NFTname);
        data.append("NFT_price", price);
        data.append("NFT_royalties", royalty);
        data.append("NFT_resell", 'on');
        data.append("NFT_payment", currency);
        data.append("NFT_owner_address", account);
        data.append("NFT_discription", description);
        data.append("NFT_category", category);
        data.append("NFT_id", tokenId);
        data.append("NFT_collection", collection);
        data.append("tokenImage", fileImg);
        data.append("stat", statename);
        data.append("statvalue", statevalue);
        data.append("level", levelname);
        data.append("levelvalue", levelvalue);
        data.append("property", propertyname);
        data.append("propertyvalue", propertyvalue);
        data.append("Member_nft", '0');
        data.append("Notarize",1);
        data.append("Private_nft", Private);
        data.append("paymentcurrency", contract_address);
        data.append("NFT_chainid", chainId);
        data.append("Tokens", '0');
        data.append("TokenName", '0');

        return await axios.post(`${API_URL}/save.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    };

    
    function changeroyalty(e) {
        setroyalty(e.target.value);
        let royalty = e.target.value;
        if (royalty > 50) {
            setdisable(true);
        } else {
            setdisable(false);
        }
    }

    useEffect(() => {
        categorydata();
    }, []);

    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Notarize
                    </Typography>
                </Box>
            </Box>

            <Box className=''>
                <Container maxWidth='md'>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <Box className='create_items' component='form' method='post' onSubmit={handlesubmit}>
                                <Typography variant='h5' fontWeight='500' fontSize='17px' paddingBottom='5px' paddingTop='10px'>Drop any file here</Typography>
                                <Box className='recognize'>
                                    <Typography variant='h6' fontWeight='400' fontSize='16px' paddingBottom='20px'>JPG, PNG, GIF, MP4,MP3 Max 100mb.</Typography>
                                    <Stack direction="row" spacing={2}>
                                     
                                        <Button variant="contained" component="label">
                                            Choose File
                                            <input hidden accept="image/*,video/*,audio/*" name="image" multiple type="file" onChange={(e)=>{setimage(e.target.files[0].name)}}/>
                                        </Button>
                                    </Stack>
                                    <Typography>{getimage && getimage}</Typography>
                                </Box>
                         

                                <Box className='form_start'>
                                    {/* <Container maxWidth='xl'> */}
                                    <Grid container>
                                        <Grid item lg={12} sm={12} xs={12}>
                                            <Box className='fdsf' paddingTop='15px'>
                                                <Label className='lab_dec'>Enter NFT name</Label>
                                                <TextField className='out_len' fullWidth id="outlined-basic" placeholder='Item name' variant="outlined" name='title' />
                                                <Label className='lab_dec'>Description of your nft in detail</Label>
                                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>The description will be included on the item's detail page underneath its image. Markdown syntax is supported.</Typography>
                                                <TextField className='out_len' fullWidth id="outlined-basic" name='description' placeholder='Provide a detailed description of your item.' variant="outlined" />
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} sm={12} xs={12}>
                                            <Box className='fdsf'>
                                                <Label className='lab_dec'>Royality</Label>
                                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Earn a percentage of the sale price every time one of your items is sold.</Typography>
                                                <TextField fullWidth id="outlined-basic" type='number' inputProps={{
                                                    min: 0,
                                                    step: 'any'
                                                }} variant="outlined" defaultValue="0" name='royalty'  onChange={changeroyalty} />
                                                <h5 style={{ color: "red" }}>
                                                    {royalty > 50 && "Enter the royalty less than 50%"}
                                                </h5>
                                            </Box>
                                        </Grid>

                                        <Grid item lg={6} sm={6} xs={12}>
                                            <Label className='lab_dec'>Product Price</Label>
                                            <TextField className='out_len' fullWidth id="outlined-basic" placeholder='Enter a price' type='number' inputProps={{
                                                min: 0,
                                                step: 'any'
                                            }} variant="outlined" name="price" />
                                        </Grid>
                                        <Grid item lg={6} sm={6} xs={12}>
                                            <Label className='lab_dec'>Select Token</Label>
                                            <FormControl fullWidth>
                                                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                                </InputLabel>
                                                <NativeSelect defaultValue="MATIC" name="currency" onChange={changecurrency} >
                                                    {/* <option value="BNB">BNB</option> */}
                                                    <option value="MATIC">MATIC</option>
                                                    {/* <option value="ETH">ETH</option> */}
                                                </NativeSelect>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={12} sm={12} xs={12}>
                                            <Label className='lab_dec'>Select Type</Label>
                                            <FormControl fullWidth>
                                                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                                </InputLabel>
                                                <NativeSelect defaultValue="1" name='NFtType' onChange={(e)=>Settypenft(e.target.value)} >
                                                    <option value="1">Private</option>
                                                    <option value="0">Public</option>

                                                </NativeSelect>
                                            </FormControl>
                                        </Grid>

                                        <Grid item lg={12} sm={6} xs={12} paddingTop='15px'>
                                            <Box >
                                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'>  NFT’s Stats </Typography>
                                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Numerical traits that just show as numbers</Typography>
                                                <Nftstats state={state} setState={setState}/>
                                            </Box>
                                            <Grid container spacing={2} marginY='5px'>
                                            {state && state.map((state,index)=>(
                                                <Grid key={index} item lg={3} sm={12} xs={12}>
                                                <Box className='trait'>
                                                    <Typography variant='h6' fontSize='16px' fontWeight='300'> {state.name} </Typography>
                                                    <Typography variant='h3' fontSize='20px' fontWeight='600'> {state.value}/5</Typography>
                                                </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                        </Grid>
                                        
                                        <Grid item lg={12} sm={6} xs={12} paddingTop='15px'>
                                            <Box >
                                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'>  NFT’s Properties </Typography>
                                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Textual traits that show up as rectangles</Typography>
                                                <Nftproperties property={property} setProperty={setProperty} />
                                            </Box>
                                            <Grid container spacing={2} marginY='5px'>
                                            {property && property.map((prop,idx)=>(
                                            <Grid key={idx} item lg={3} sm={12} xs={12}>
                                                <Box className='trait'>
                                                    <Typography variant='h6' fontSize='16px' fontWeight='300'> {prop.type}</Typography>
                                                    <Typography variant='h3' fontSize='20px' fontWeight='600'> {prop.propname}</Typography>
                                                </Box>
                                            </Grid>
                                            ))}
                                        </Grid>
                                        </Grid>

                                        <Grid item lg={12} sm={12} xs={12} paddingTop='15px'>
                                            <Box >
                                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'>  NFT’s Levels </Typography>
                                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Numerical traits that show as a progress bar</Typography>
                                                <NFTLevels level={level} setlevel={setlevel} />
                                            </Box>
                                            <Grid container spacing={2} marginY='5px'>
                                            {level && level.map((level,index)=>(
                                                <Grid key={index} item lg={3} sm={12} xs={12}>
                                                <Box className='trait'>
                                                    <Typography variant='h6' fontSize='16px' fontWeight='300'> {level.name} </Typography>
                                                    <Typography variant='h3' fontSize='20px' fontWeight='600'> {level.value} /5</Typography>
                                                </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                        </Grid>

                                        <Grid item lg={12} sm={12} xs={12} paddingTop='10px'>
                                            <Label>Category</Label>
                                            <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Adding a category will help make your item discoverable on mintdaq</Typography>

                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label"> </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select" name="category"
                                                    value={Categoryvalue}
                                                    onChange={e => setcategory(e.target.value)}
                                                >
                                                    {category.length > 0 && category.map((data) => (
                                                        <MenuItem value={data.category_name} key={data.id}> {data.category_name} </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item lg={12} sm={12} xs={12}  paddingTop='10px'>
                                            <Label>Collection</Label>
                                            <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>  This is the collection where your item will appear.
                                            </Typography>

                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label"> </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={collectionvalue}
                                                    onChange={e => setcollectionvalue(e.target.value)}
                                                >
                                                    <MenuItem value="ENEFTI">ENEFTI</MenuItem>
                                                    {collection.length > 0 && collection.map((data, idx) => (
                                                        <MenuItem value={data.collection_name} key={idx} >{data.collection_name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <Box className='coll_det' marginY='20px'>
                                                <Button type="submit" variant="contained" > submit</Button>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                    {/* </Container> */}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            {isloading && (
                <Loading props={'Transaction in process, Please wait do not refresh the page...'} />
            )}
        </div>
    )
}

export default Notarize